import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import sleep from 'sleep-promise';
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const path = '/projectdocumentations/';
    const paths = {
        endpointSave: config.endpoints.backend + 'documentations/save',
        endpointGetById: config.endpoints.backend + 'documentations/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllDocumenationCategories: config.endpoints.backend + 'documentationcategories/getall',
        endpointGetAllDocumentTypes: config.endpoints.backend + 'documenttypes/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Documentação",
        labelTitleEdit: "Editar Documentação",
        labelTitleView: 'Visualizar Documentação'
    }

    const getForm = (values, options) => {
        options.DocumentTypeOptionsEndpoint = values != {} && values.pdc_category_id != "" && values.pdc_category_id ? {
            endpoint: paths.endpointGetAllDocumentTypes,
            label: 'name',
            value: 'id',
            params: {
                filter: {
                    pdc_category_id: values.pdc_category_id
                }
            }
        } : {}

        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_category_id',
                    type: 'select',
                    label: 'Categoria',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumenationCategories,
                        label: 'name',
                        value: 'id'
                    },
                    value: values.pdc_category_id ? values.pdc_category_id : null,
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values, options);

                        values.pdc_document_type_id = '';

                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                },
                {
                    name: 'pdc_document_type_id',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumentTypes,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                pdc_category_id: values.pdc_category_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    maxLength: 500,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'publish_date',
                    type: 'date',
                    label: 'Data de Publicação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            let options = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values, options);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
